<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true">
    <!-- Backdrop -->
    <div class="fixed inset-0 bg-gray-500/75 transition-opacity" @click="close"></div>

    <!-- Modal Panel -->
    <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm">
      <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <font-awesome-icon icon="exclamation-triangle" class="h-6 w-6 text-red-600" />
          </div>
          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">{{ title }}</h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500 whitespace-pre-wrap">{{ formattedMessage }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <button 
          type="button" 
          class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 sm:ml-3 sm:w-auto" 
          @click="close"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Erreur'
  },
  message: {
    type: [String, Object],
    default: 'Une erreur est survenue.'
  }
})

const emit = defineEmits(['close'])

const formattedMessage = computed(() => {
  if (typeof props.message === 'string') return props.message
  if (props.message && typeof props.message === 'object') {
    return JSON.stringify(props.message, null, 2)
  }
  return 'Une erreur est survenue.'
})

const close = () => {
  emit('close')
}
</script>
